import placeholder from "../img/placeholder.png";
import AIComparison from "../img/AIcomparison.png";
import driverComparison from "../img/drivercomparison.png";
import uploadLaptimes from "../img/uploadlaptimeplaceholder.png";
import raceAnalysis from "../img/raceAnalysis.png";
import React, { useState, useEffect, useRef } from "react";

// Simple carousel template for the app models page.
// Each slide shows a placeholder image, the human label, and a variable name placeholder.
const Models = () => {
  const features = [
    { label: "Race Analysis", image: raceAnalysis },
    { label: "Lap Analysis", image: AIComparison },
    { label: "Driver Comparison", image: driverComparison },
    { label: "Gear Figure", image: uploadLaptimes },
    { label: "Lap Time Comparison", image: placeholder },
  ];

  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    // start auto-advance
    const startAuto = () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setIndex((i) => (i + 1) % features.length);
      }, 6000);
    };

    startAuto();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [features.length]);

  const prev = () =>
    setIndex((i) => (i - 1 + features.length) % features.length);
  const next = () => setIndex((i) => (i + 1) % features.length);

  // restart the auto-advance timer when the user interacts
  const restartAutoAdvance = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % features.length);
    }, 6000);
  };

  return (
    <div className="model-container">
      <div className="model-header">
        Explore our visualisations and enhance your analysis!
      </div>

      <div className="models-carousel">
        <button
          className="carousel-btn prev"
          onClick={prev}
          aria-label="Previous"
        >
          ‹
        </button>

        {features.map((f, i) => (
          <div
            key={f.varName}
            className={`model-slide ${i === index ? "active" : "inactive"}`}
            style={{ display: i === index ? "block" : "none" }}
          >
            <div className="model-image">
              <img src={f.image} alt={`${f.label} image`} />
            </div>
            <div className="model-caption">
              <div className="model-label">{f.label}</div>
            </div>
          </div>
        ))}

        <button className="carousel-btn next" onClick={next} aria-label="Next">
          ›
        </button>
      </div>

      <div className="carousel-dots">
        {features.map((_, i) => (
          <button
            key={`dot-${i}`}
            className={`dot ${i === index ? "dot-active" : ""}`}
            onClick={() => setIndex(i)}
            aria-label={`Show ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Models;
